import * as actionTypes from "../actionTypes";

const initalState = {
  searchBar: "",
  stateValue: "",
  start_date: "",
  end_date: new Date().toJSON(),
};

export const searchReducer = (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.ClientSideSearch.SEARCH_BAR:
      return {
        ...state,
        searchBar: action.payload,
      };
    case actionTypes.ClientSideSearch.START_DATE:
      return {
        ...state,
        start_date: action.payload,
      };
    case actionTypes.ClientSideSearch.END_DATE:
      return {
        ...state,
        end_date: action.payload,
      };
    case actionTypes.ClientSideSearch.STATE_BAR:
      return {
        ...state,
        stateValue: action.payload,
      };
    default:
      return state;
  }
};
